import {
	CUSTOMER,
	CUSTOMERS,
	SET_CUSTOMER,
	SET_CUSTOMERS
} from './mutation-types';
import _ from 'lodash';

export default {
	strict: process.env.NODE_ENV !== 'production',
	state: {
		[CUSTOMER]: {},
		[CUSTOMERS]: {},
		permissions: {},
		roles: {},
		users: {},
		breadcrumbs: []
	},
	mutations: {
		[SET_CUSTOMER](state, data) {
			state[CUSTOMER] = data;
		},
		[SET_CUSTOMERS](state, data) {
			state[CUSTOMERS] = data;
		},
		setRolesPermissions(state, data) {
			state.roles = data.roles;
			state.permissions = data.permissions;
		},
		setUsers(state, data) {
			state.users = data;
		},
		setRoles(state, obj) {
			const idx = state.roles.items?.findIndex(
				x => x.roleId === obj.role.roleId
			);
			if (idx > -1) {
				if (obj.remove) {
					state.roles.items.splice(idx, 1);
					return;
				}
				state.roles.items[idx] = obj.role;
				if (state.users.items && state.users.items.length) {
					state.users.items.forEach(user => {
						if (user.roleId === obj.role.roleId) {
							user.role = obj.role.role;
						}
					});
				}
			} else {
				state.roles.items.push(obj.role);
			}
		},
		setBreadCrumbs(state, obj) {
			if (!state.breadcrumbs.some(item => item.path === obj.path)) {
				state.breadcrumbs.push(obj);
			}
		}
	},
	actions: {
		[SET_CUSTOMER]({ commit }, obj) {
			commit(SET_CUSTOMER, obj);
		},
		async [SET_CUSTOMERS]({ commit }, obj) {
			commit(SET_CUSTOMERS, obj);
		},
		setLocalStorageRolesPermissionsAction({ commit }, obj) {
			commit('setRolesPermissions', obj);
		},
		setLocalStorageRolesAction({ commit }, obj) {
			commit('setRoles', obj);
		},
		setLocalStorageUsersAction({ commit }, obj) {
			commit('setUsers', obj);
		},
		setLocalStoragePreviousSearches({ commit }, obj) {
			commit('setPreviousSearches', obj);
		}
	},
	getters: {
		localStorage: state => {
			const items = state.roles.items || [];
			let opts = [];
			if (items.length) {
				opts = items.map(item => {
					let { roleId, role } = item;
					return {
						text: role,
						value: roleId
					};
				});
			}
			return {
				optionRoles: opts
			};
		},
		breadcrumbs: state => path => {
			const obj = state.breadcrumbs.find(
				breadcrumb => breadcrumb.path === path
			);

			if (_.isEmpty(obj)) {
				return [];
			}

			return obj.breadcrumb || [];
		}
	}
};
